import {CONSONANT_VOWEL_PAIRS_K} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_k";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_K_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_K} title="Consonant-Vowel Pairs: ㅋ (k)" />
     </>
);}